import React from 'react'

import experienceDetails from "../project_info/experienceDetails"

function Experience() {
  return (
    <div
    name="experience" className='bg-gradient-to-b from-gray-800
    to-black w-full '>
        <div className='max-w-screen-lg mx-auto p-4 flex
        flex-col justify-center w-full h-full text-white'>
            <div>
                <p className='text-4xl font-bold inline border-b-4
                border-gray-500 p-2'>
                    Experience
                </p>
                <p className='py-6'>
                    These are the technologies I've worked with
                </p>
            </div>
            <div className='w-full grid grid-cols-2 sm:grid-cols-3
            gap-8 text-center py-8 px-12 sm:px-0'>
            {experienceDetails.map(({id, srcs, title, style}) => (
                <div key={id}
                className={`shadow-md hover:scale-105duration-500
                py-2 rounded-lg ${style}`}>
                    <img src={srcs} alt='' className='w-20 mx-auto'/>
                    <p className='mt-4'> {title} </p>
                </div>
            ))}
            </div>
        </div>
    </div>
  )
}

export default Experience